module.exports = __webpack_public_path__ + "media/images/loader-f22b054d2f9a653eac8c979223dbc256.gif";